import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { authClient } from "@/lib/auth";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

interface AppShellProps {
  user: { id: string; email: string; name?: string | null; image?: string | null } | null;
}

export function AppShell({ user }: AppShellProps) {
  const navigate = useNavigate();
  const qc = useQueryClient();

  const handleSignOut = async () => {
    try {
      await authClient.signOut();
    } catch (err) {
      toast.error("Sign out failed", { description: err instanceof Error ? err.message : "Unknown error" });
      return;
    }
    qc.clear();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar user={user} onSignOut={handleSignOut} />
        <main className="flex-1 overflow-y-auto scrollbar-thin">
          <div className="mx-auto w-full max-w-[1600px] px-6 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
